// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const OnboardingStressGuidedIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<circle cx={22} cy={22} r={22} fill="url(#OnboardingStressGuidedIcon_tsx__a)" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M33.111 28.076H10.888a.667.667 0 1 0 0 1.333H33.11a.667.667 0 0 0 0-1.333Zm-2.441 4.059H13.328a.667.667 0 0 0 0 1.333H30.67a.667.667 0 1 0 0-1.333Zm-1.838-8.118A6.843 6.843 0 0 0 22 17.355c-3.711 0-6.74 2.973-6.832 6.662h13.664Zm6.334.666a.667.667 0 0 1-.666.667h-25a.666.666 0 1 1 0-1.333h4.334c.092-4.424 3.72-7.996 8.166-7.996s8.074 3.572 8.166 7.996H34.5c.368 0 .666.299.666.666ZM22 13.903a.667.667 0 0 0 .666-.667v-3.37a.667.667 0 0 0-1.333 0v3.37c0 .369.298.667.667.667Zm-8.216 3.013a.664.664 0 0 0 .942 0 .667.667 0 0 0 0-.943l-2.383-2.383a.667.667 0 1 0-.943.943l2.384 2.383Zm15.489 0a.667.667 0 0 1 0-.943l2.383-2.383a.667.667 0 1 1 .943.943l-2.384 2.383a.664.664 0 0 1-.942 0Z"
			fill="#fff"
		/>
		<defs>
			<linearGradient
				id="OnboardingStressGuidedIcon_tsx__a"
				x1={-22}
				y1={22}
				x2={22}
				y2={66}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#75F094" />
				<stop offset={1} stopColor="#75B2F0" />
			</linearGradient>
		</defs>
	</svg>
);
export default OnboardingStressGuidedIcon;
